module.exports = __webpack_public_path__ + "static/img/BJM.0d518d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/BJM.png
// module id = zTjU
// module chunks = 1